import { PureComponent } from 'react'
import context from 'meta/context'
import Page from 'components/layout/Page'
import PageClick from 'react-page-click'
import api from 'connections/api'
import { groupBy, orderBy } from 'lodash'
import PropTypes from 'meta/PropTypes'
import cn from 'classnames'
import { Layout, Box, Flex } from 'react-flex-lite'
import LinkButton from 'components/interactive/LinkButton'
import { Hero, HeroHeader, HeroContent } from 'components/layout/Hero'
import PlaceCard from 'components/display/PlaceCard'
import format from 'lib/format'
import { passOn } from 'lib/redirectTo'
import { get as getQueryParams } from 'lib/qs'
import pluralize from 'pluralize'
import analytics from 'connections/analytics'
import debounce from 'debounce-promise'
import { MdArrowForward, MdBubbleChart, MdAddBox, MdBuild } from 'components/display/Icons'
import { getURL } from 'lib/hub'
import BlogPosts from 'components/display/BlogPosts'
import MarketingFooter from 'components/display/MarketingFooter'
import ErrorMessage from 'components/display/Error'
import { Headline, Title, Subtitle, Paragraph, Small, Medium } from 'components/display/Text'
import iconify from 'lib/iconify'
import staeLogo from 'assets/logo-text-white.svg'
import humilityImage from 'assets/icons/humility.svg'
import shareImage from 'assets/icons/share-updates.svg'
import mapImage from 'assets/icons/current.svg'
import mapVideo from 'assets/open-map.mp4'
import Search from 'components/interactive/Search'
import heroBg from 'assets/explore-background.jpg'
import scfLogo from 'assets/integrations/seeclickfix-logo.svg'
import plotlyLogo from 'assets/integrations/plotly-logo.svg'
import cartoLogo from 'assets/integrations/carto-logo.svg'
import transitlandLogo from 'assets/integrations/transitland-logo.svg'
import wazeLogo from 'assets/integrations/waze-logo.svg'
import tableauLogo from 'assets/integrations/tableau-logo.svg'
import openaqLogo from 'assets/integrations/openaq-logo.svg'
import mark43Logo from 'assets/integrations/mark43-logo.svg'
import './index.scss'

const featuredOrder = [
  'primary',
  'city',
  'state',
  'country',
  'planet'
]
const primaryFeatured = [
  'lou-ky',
  'guil-nc',
  'ridot'
]
const featured = [
  // states
  'ca',
  'az',
  'ny'

  // planets
  // 'earth'
]

const HumilityImage = iconify(humilityImage)
const ShareImage = iconify(shareImage)
const MapImage = iconify(mapImage)
const FlexVideo = Layout((props) => <video {...props} />)
const demoMap = 'https://sf-ca.municipal.systems/map#q=JTdCJTIybWFwJTIyJTNBJTdCJTIydmlld3BvcnQlMjIlM0ElN0IlMjJsYXRpdHVkZSUyMiUzQTM3Ljc4NDA1MzAzOTI4OTAyJTJDJTIybG9uZ2l0dWRlJTIyJTNBLTEyMi40MTEyNTkwNjA0MDczMiUyQyUyMnpvb20lMjIlM0ExMy4wNzU1NjA3MzI3MTAxMDklMkMlMjJwaXRjaCUyMiUzQTYwJTJDJTIyYmVhcmluZyUyMiUzQTAlMkMlMjJhbHRpdHVkZSUyMiUzQTEuNSU3RCU3RCUyQyUyMnRoZW1lJTIyJTNBJTIyZGFyayUyMiUyQyUyMnZpc3VhbGl6YXRpb24lMjIlM0ElMjIzZCUyMiUyQyUyMnZpc3VhbGl6YXRpb25TZXR0aW5ncyUyMiUzQSU3QiUyMmhleCUyMiUzQWZhbHNlJTJDJTIyaGV4U2l6ZSUyMiUzQTUwJTdEJTJDJTIyZWRpdG9yQWN0aXZlJTIyJTNBZmFsc2UlMkMlMjJhdXRvUmVmcmVzaEVuYWJsZWQlMjIlM0FmYWxzZSUyQyUyMmZ1bGxTY3JlZW5FbmFibGVkJTIyJTNBZmFsc2UlMkMlMjJkYXRhTGF5ZXJzJTIyJTNBJTdCJTIyc2hhcmVkLXZlaGljbGUlMjIlM0ElN0IlMjJ1cGRhdGVkQXQlMjIlM0ElMjIyMDE4LTEyLTEwVDE5JTNBMTIlM0EyMS45OTJaJTIyJTJDJTIyZGF0YVR5cGVJZCUyMiUzQSUyMnNoYXJlZC12ZWhpY2xlJTIyJTdEJTJDJTIydHJhbnNpdC12ZWhpY2xlJTIyJTNBJTdCJTIydXBkYXRlZEF0JTIyJTNBJTIyMjAxOC0xMi0xMFQxOSUzQTEyJTNBMjYuOTE5WiUyMiUyQyUyMmRhdGFUeXBlSWQlMjIlM0ElMjJ0cmFuc2l0LXZlaGljbGUlMjIlN0QlMkMlMjJ0cmFuc2l0LXN0YXRpb24lMjIlM0ElN0IlMjJ1cGRhdGVkQXQlMjIlM0ElMjIyMDE4LTEyLTEwVDE5JTNBMTIlM0EyNy42MzlaJTIyJTJDJTIyZGF0YVR5cGVJZCUyMiUzQSUyMnRyYW5zaXQtc3RhdGlvbiUyMiU3RCUyQyUyMnRyYW5zaXQtcm91dGUlMjIlM0ElN0IlMjJ1cGRhdGVkQXQlMjIlM0ElMjIyMDE4LTEyLTEwVDE5JTNBMTIlM0EyOC4zNDlaJTIyJTJDJTIyZGF0YVR5cGVJZCUyMiUzQSUyMnRyYW5zaXQtcm91dGUlMjIlN0QlN0QlN0Q%3D'


@context([ 'me' ])
export default class Explore extends PureComponent {
  static propTypes = {
    me: PropTypes.user,
    location: PropTypes.location.isRequired
  }
  static getDerivedStateFromProps = (props) => {
    const query = getQueryParams({ location: props.location })
    return {
      isLoggedIn: !!props.me,
      showAll: typeof query.all !== 'undefined'
    }
  }
  state = {
    isLoggedIn: null,
    search: '',
    searchActive: false,
    error: null,
    featured: null,
    results: null,
    showAll: false
  }
  componentDidMount = () => {
    this.resolveFeatured()
  }
  resolveFeatured = async () => {
    const { showAll } = this.state
    const list = [
      ...primaryFeatured,
      ...featured
    ]
    const constraints = showAll
      ? { limit: 10000 }
      : {
        limit: list.length,
        filters: [
          {
            id: list
          }
        ]
      }
    return api.place.find({
      retry: 3,
      options: {
        includes: [
          { resource: 'boundary', attributes: [ 'type' ] }
        ],
        ...constraints
      }
    })
      .then(({ body }) => {
        const res = orderBy(body.results, [ 'data' ], [ 'desc' ])
        this.setState({
          featured: groupBy(res, (i) =>
            primaryFeatured.includes(i.id)
              ? 'primary'
              : i.boundary.type
          )
        })
      })
      .catch((error) => this.setState({ error }))
  }
  resolveSearch = async (search) => {
    analytics.track('Explore:Search', { search })
    return api.place.find({
      retry: 3,
      options: { search }
    })
      .then(({ body }) => {
        this.setState({ results: body.results })
      })
      .catch((error) => console.error(error))
  }
  debouncedSearch = debounce(this.resolveSearch, 300)
  handleSearch = async (e) => {
    const search = e.target.value
    this.setState({ search, searchActive: true })
    if (search) return this.debouncedSearch(search)
  }
  closeSearch = () => {
    this.setState({ searchActive: false })
  }
  openSearch = () => {
    this.setState({ searchActive: true })
  }
  trackPlace = (id) => {
    analytics.track('Explore:PlaceSelect', { id })
  }
  renderHeader = () => {
    const { isLoggedIn } = this.state
    const signupUrl = passOn('/signup', { local: true })
    const titleBar = !isLoggedIn ? <HeroHeader>
      <img className="logo" src={staeLogo} alt="Stae logo" />
      <LinkButton ml={3} plain white to="/login">
        Sign In
      </LinkButton>
    </HeroHeader> : null
    return <Hero backgroundImage={heroBg}>
      {titleBar}
      <HeroContent>
        {isLoggedIn
          ? <Box className="text-content">
            <Title mb={1}>Explore with Stae</Title>
            <Paragraph className="page-desc">Create and build with real-time civic data from around the world.</Paragraph>
          </Box>
          : <Box className="text-content">
            <Headline mb={2}>Explore with Stae</Headline>
            <Title weight="normal" mb={3}>Create and build with real-time civic data from around the world.</Title>
            <LinkButton mb={3} primary IconRight={MdArrowForward} to={signupUrl} text="Sign up" />
          </Box>}
        {this.renderSearch()}
      </HeroContent>
    </Hero>
  }
  renderSearch = () => {
    const { results, search, searchActive } = this.state

    return <PageClick notify={this.closeSearch}>
      <Box className="search-control" onClick={this.openSearch}>
        <Search
          className="search-box"
          placeholder="Search Places"
          value={search}
          onChange={this.handleSearch}
          clearable />
        {search && searchActive && results && <Flex column className="search-results">
          {results.length === 0
            ? <Box className="search-result empty">No results!</Box>
            : results.map((i) =>
              <a
                className="search-result"
                href={getURL(i, { allowCustom: false })}
                onClick={this.trackPlace.bind(this, i.id)}
                key={i.id}>
                {i.name}
              </a>
            )}
        </Flex>}
      </Box>
    </PageClick>
  }
  renderFeatured = () => {
    const { featured } = this.state
    if (!featured) return null // TODO: placeholders
    return <Flex column className="featured">
      <Title className="featured-label">Featured</Title>
      {featuredOrder.map((type, idx) => {
        const places = featured[type]
        const first = idx === 0
        if (!places) return null
        return <Flex column mb={3} key={type}>
          {!first && <Small uppercase className="category-label">Featured {pluralize(format(type))}</Small>}
          <Flex wrap>
            {places.map((place) =>
              <PlaceCard
                className="featured-card"
                onClick={this.trackPlace.bind(this, place.id)}
                to={getURL(place, { allowCustom: false })}
                place={place} full={first}
                key={place.id} />
            )}
          </Flex>
        </Flex>
      })}
    </Flex>
  }
  renderIntegrations = () => {
    if (this.state.isLoggedIn) return null
    return <Flex column className="integrations" mb={3}>
      <Small uppercase className="category-label">Featured Integrations</Small>
      <Flex wrap center className="images">
        <img alt="SeeClickFix logo" src={scfLogo} />
        <img alt="Plotly logo" src={plotlyLogo} />
        <img alt="Carto logo" src={cartoLogo} />
        <img alt="Transitland logo" src={transitlandLogo} />

        <img alt="Waze logo" src={wazeLogo} />
        <img alt="Tableau logo" src={tableauLogo} />
        <img alt="OpenAQ logo" src={openaqLogo} />
        <img alt="Mark43 logo" src={mark43Logo} />
      </Flex>
    </Flex>
  }
  renderInfo = () =>
    <Flex
      auto wrap className="info"
      align="center" justify="space-between">
      <Flex column align="flex-start" justify="flex-start" className="info-item">
        <HumilityImage size={48} mb={3} />
        Create data sources with their own APIs and share them with the community.
      </Flex>
      <Flex column align="flex-start" justify="flex-start" className="info-item">
        <ShareImage size={48} mb={3} />
        Access clean, interoperable, and consistent data across locations and types.
      </Flex>
      <Flex column align="flex-start" justify="flex-start" className="info-item primary active">
        <MapImage size={48} mb={3} />
        Quickly query and map data from anywhere in the world — from data to insight faster than ever.
        <LinkButton
          plain mt={3} auto
          IconRight={MdArrowForward}
          to={demoMap}>Getting around in San Francisco</LinkButton>
      </Flex>
    </Flex>
  renderUses = () =>
    <Flex auto column className="uses">
      <Box mb={4}>
        <Title mb={2}>Create with Stae</Title>
        <Paragraph>{"Here's a few ways people use Stae to make the most of civic data."}</Paragraph>
      </Box>
      <Flex auto wrap className="uses-content">
        <LinkButton
          className="use-item"
          column dark alignText="left"
          to="https://observablehq.com/@cpenalosa/stae-module-basics">
          <Flex align="center" mb={1} justify="space-between" className="use-item-header">
            <Subtitle>Ask</Subtitle>
            <MdBubbleChart size={24} style={{ color: '#3EC15D' }} />
          </Flex>
          <Medium>Run nimble queries on more than 60 types of civic data.</Medium>
        </LinkButton>

        <LinkButton
          className="use-item"
          column dark alignText="left"
          to="https://medium.com/city-as-a-service/https-medium-com-adrianavyoung-the-hey-mayor-app-55c09b5ad27e">
          <Flex align="center" mb={1} justify="space-between" className="use-item-header">
            <Subtitle>Connect</Subtitle>
            <MdAddBox size={24} style={{ color: '#ffc400' }} />
          </Flex>
          <Medium>Integrate real-time civic data into your everyday life.</Medium>
        </LinkButton>

        <LinkButton
          className="use-item"
          column dark alignText="left"
          to="https://medium.com/city-as-a-service/hack-upstate-debrief-24837aa2f77a">
          <Flex align="center" mb={1} justify="space-between" className="use-item-header">
            <Subtitle>Build</Subtitle>
            <MdBuild size={24} style={{ color: '#5b4ae0' }} />
          </Flex>
          <Medium>Use our APIs to build new applications, or add meaningful context to existing ones.</Medium>
        </LinkButton>
      </Flex>
      <FlexVideo
        mb={3} src={mapVideo}
        autoPlay loop playsInline muted />
    </Flex>
  renderContent = () => {
    const { error, isLoggedIn } = this.state
    if (error) return <ErrorMessage error={error} />
    return <>
      {this.renderFeatured()}
      {this.renderIntegrations()}
      {!isLoggedIn && this.renderUses()}
      {!isLoggedIn && this.renderInfo()}
      {!isLoggedIn && <BlogPosts />}
      {!isLoggedIn && <MarketingFooter />}
    </>
  }
  render = () => {
    const { isLoggedIn } = this.state
    const classnames = cn('explore-component', { 'logged-in': isLoggedIn })
    const title = {
      plain: true,
      title: 'Explore',
      description: 'Explore real-time civic data from around the world.'
    }

    return <Page className={classnames} title={title} data-testid="explore-view">
      {this.renderHeader()}
      <Flex column shrink={0} className="main-content">
        {this.renderContent()}
      </Flex>
    </Page>
  }
}
